export default "__VITE_ASSET__CFhf4Tea__"